var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/utils/sites.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = 1;
frame.set("SITE_MAIN", t_1, true);
if(frame.topLevel) {
context.setVariable("SITE_MAIN", t_1);
}
if(frame.topLevel) {
context.addExport("SITE_MAIN", t_1);
}
output += "\n";
var t_2;
t_2 = 2;
frame.set("SITE_AVAILABILITY", t_2, true);
if(frame.topLevel) {
context.setVariable("SITE_AVAILABILITY", t_2);
}
if(frame.topLevel) {
context.addExport("SITE_AVAILABILITY", t_2);
}
output += "\n";
var t_3;
t_3 = 3;
frame.set("SITE_SUBMISSIONS", t_3, true);
if(frame.topLevel) {
context.setVariable("SITE_SUBMISSIONS", t_3);
}
if(frame.topLevel) {
context.addExport("SITE_SUBMISSIONS", t_3);
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/utils/sites.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/utils/sites.jinja
// module id = 18
// module chunks = 0